import {prefixWithSeparator} from '@management-ui/core';
import React, {useMemo} from 'react';
import {useFormContext} from 'react-hook-form';
import YesNoSwitch from './YesNoSwitch';

const YesNoField = ({name, prefix, label}) => {
  const {setValue, /** @var {function(string): string} */watch} = useFormContext();
  const prefixed = useMemo(() => `${prefixWithSeparator(prefix)}${name}`, [name, prefix]);
  const value = watch(prefixed);

  return <YesNoSwitch checked={!!value} setChecked={(updated) => setValue(prefixed, updated)} label={label}/>;
}

export default YesNoField;
